import { FirebaseApp, initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

export function initializeAppWithConfig(): FirebaseApp {
    return initializeApp(firebaseConfig);
}

export function getFirebaseToken(): Promise<String> {
    const firebaseApp = initializeApp(firebaseConfig);
    const messaging = getMessaging(firebaseApp);
    return new Promise(async (resolve, reject) => {
        const swRegistration = await navigator.serviceWorker.getRegistration();
        getToken(messaging, {
            vapidKey: process.env.REACT_APP_PUSH_API_KEY,
            serviceWorkerRegistration: swRegistration,
        })
            .then((currentToken) => resolve(currentToken))
            .catch((reason) => reject(reason));
    });
}

export const onMessageListener = () => {
    const firebaseApp = initializeApp(firebaseConfig);
    const messaging = getMessaging(firebaseApp);
    return new Promise((resolve) => {
        onMessage(messaging, (payload) => {
            resolve(payload);
        });
    });
};
